// extracted by mini-css-extract-plugin
export default {"topbar":"TopBar_topbar__T-uwW","logo":"TopBar_logo__FCKso","rightArea":"TopBar_rightArea__9ELmV","iconContainer":"TopBar_iconContainer__MJGvl","icon":"TopBar_icon__Q6dSy"};